import React from 'react';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { Add as AddIcon, DeleteOutline as DeleteIcon } from '@mui/icons-material';
import { MAX_INPUTS, inputLabel } from '../../utils/datasetMappingUtils';
import type { InputForm } from '../../utils/datasetMappingUtils';

interface DatasetInputTabsProps {
  inputs: InputForm[];
  selected: number;
  /** Inputs with a refusal to show, marked on their tab. */
  withErrors: Set<number>;
  disabled: boolean;
  onSelect: (input: number) => void;
  onAdd: () => void;
  onRemove: (input: number) => void;
}

const TAB_SX = { minHeight: 36, py: 0, textTransform: 'none', fontSize: 13 } as const;

/** One tab per input, each an event format feeding the same columns; inputs are only appended. */
const DatasetInputTabs: React.FC<DatasetInputTabsProps> = ({ inputs, selected, withErrors, disabled, onSelect, onAdd, onRemove }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, borderBottom: 1, borderColor: 'divider', mb: 2 }}>
    <Tabs value={selected} onChange={(_, v: number) => onSelect(v)} variant="scrollable" scrollButtons="auto" sx={{ minHeight: 36, flex: 1 }}>
      {inputs.map((_, n) => (
        <Tab key={n} value={n} label={inputLabel(n)} sx={{ ...TAB_SX, ...(withErrors.has(n) ? { color: 'error.main' } : {}) }} />
      ))}
    </Tabs>
    {inputs.length > 1 && !inputs[selected].locked && (
      <Button size="small" startIcon={<DeleteIcon />} onClick={() => onRemove(selected)} disabled={disabled}>
        Remove {inputLabel(selected).toLowerCase()}
      </Button>
    )}
    <Button size="small" startIcon={<AddIcon />} onClick={onAdd} disabled={disabled || inputs.length >= MAX_INPUTS}>
      Add input
    </Button>
  </Box>
);

export default DatasetInputTabs;
